import { SEOHead } from '@/components/layout/SEOHead';
import { FadeIn } from '@/components/motion/FadeIn';
import { InquiryForm } from '@/components/ui/InquiryForm';
import { getContact } from '@/lib/content';

export function ContactPage() {
  const contact = getContact();

  return (
    <>
      <SEOHead
        title="Contact · Brian Ellison Design"
        description="Inquire about a new project with Brian Ellison Design — Melbourne, Florida."
        canonical="https://brianellisondesign.com/contact"
      />
      <section className="page-hero">
        <div className="container">
          <FadeIn>
            <p className="eyebrow">Get in touch</p>
            <h1 className="page-hero__title">Begin a conversation.</h1>
            <p className="subtitle">
              Tell Brian about the space and the people who will use it. He responds personally
              to every inquiry, usually within two business days.
            </p>
          </FadeIn>
        </div>
      </section>
      <section className="container section contact-grid">
        <FadeIn>
          <InquiryForm />
        </FadeIn>
        <FadeIn delay={120}>
          <aside className="contact-aside">
            <div>
              <p className="eyebrow">Direct</p>
              <p>
                <a href={`mailto:${contact.email}`} className="text-link">{contact.email}</a><br />
                <a href={`tel:${contact.phone.replace(/[^+\d]/g, '')}`} className="text-link">{contact.phone}</a>
              </p>
            </div>
            <div>
              <p className="eyebrow">Studio</p>
              <p className="caption">
                {contact.address.street}<br />
                {contact.address.city}, {contact.address.region} {contact.address.postalCode}<br />
                {contact.address.country}
              </p>
              {contact.hours?.byAppointment ? (
                <p className="caption" style={{ marginTop: 'var(--space-3)' }}>By appointment</p>
              ) : null}
            </div>
            {contact.social.instagram || contact.social.houzz ? (
              <div>
                <p className="eyebrow">Off-site</p>
                <ul style={{ display: 'flex', flexDirection: 'column', gap: 'var(--space-2)' }}>
                  {contact.social.instagram ? (
                    <li>
                      <a href={`https://instagram.com/${contact.social.instagram.replace(/^@/, '')}`} className="text-link" target="_blank" rel="noreferrer">
                        Instagram — {contact.social.instagram}
                      </a>
                    </li>
                  ) : null}
                  {contact.social.houzz ? (
                    <li><a href={contact.social.houzz} className="text-link" target="_blank" rel="noreferrer">Houzz profile</a></li>
                  ) : null}
                </ul>
              </div>
            ) : null}
          </aside>
        </FadeIn>
      </section>
    </>
  );
}
